import { FaMinus, FaPlus } from 'react-icons/fa'
import { Button } from 'react-bootstrap'
import cn from 'classnames'
import s from './NombreEtage.module.scss'

interface Props {
  value: number
  min?: number
  max?: number
  className?: string
  onMinusClick: () => void
  onPlusClick: () => void
  disabled?: boolean
}

const defaultProps = {
  min: undefined,
  max: undefined,
  className: undefined,
  disabled: false,
}

const NombreEtage = ({
  value,
  onMinusClick,
  onPlusClick,
  min,
  max,
  className,
  disabled,
}: Props): JSX.Element => {
  const handleMinusClick = () => {
    if (min && value <= min) return
    onMinusClick()
  }

  const handlePlusClick = () => {
    if (max && value >= max) return
    onPlusClick()
  }

  return (
    <div className={cn(s.nombreEtage, className, { [s.disabled]: disabled })}>
      <Button
        className={cn(s.btn, { [s.disabled]: disabled })}
        variant="outline-secondary"
        disabled={disabled || (min !== undefined && value <= min)}
        onClick={handleMinusClick}
      >
        <FaMinus />
      </Button>
      <span className={s.inputValue}>{value}</span>
      <Button
        className={cn(s.btn, { [s.disabled]: disabled })}
        variant="outline-secondary"
        disabled={disabled || (max !== undefined && value <= max)}
        onClick={handlePlusClick}
      >
        <FaPlus />
      </Button>
    </div>
  )
}

NombreEtage.defaultProps = defaultProps
export default NombreEtage
